import React from 'react';
import { HeroSection } from '../components/home/HeroSection';
import { StatsSection } from '../components/home/StatsSection';
import { AboutSection } from '../components/home/AboutSection';
import { ServicesGrid } from '../components/home/ServicesGrid';
import { ServicesSlider } from '../components/home/ServicesSlider';
import { MobileAppServices } from '../components/home/MobileAppServices';
import { LongTermCareSection } from '../components/home/LongTermCareSection';
import { VisionMissionSection } from '../components/home/VisionMissionSection';
import { CtaBanner } from '../components/home/CtaBanner';
import { PortfolioSection } from '../components/home/PortfolioSection';
import { WhyChooseUs } from '../components/home/WhyChooseUs';
import { ProcessSection } from '../components/home/ProcessSection';
import { TechStack } from '../components/home/TechStack';
import { Testimonials } from '../components/home/Testimonials';
import { DigitalMarketingPlans } from '../components/home/DigitalMarketingPlans';
import { FaqSection } from '../components/home/FaqSection';
import { ContactSection } from '../components/home/ContactSection';
import { ProjectItem } from '../types';

interface HomePageProps {
  onNavigate: (path: string) => void;
  onOpenConsultation: (serviceName?: string) => void;
  onStartProject?: () => void;
  onSelectProject: (project: ProjectItem) => void;
}

export const HomePage: React.FC<HomePageProps> = ({
  onNavigate,
  onOpenConsultation,
  onStartProject,
  onSelectProject,
}) => {
  return (
    <div className="space-y-0">
      <HeroSection 
        onExploreServices={() => {
          const el = document.getElementById('services-section');
          if (el) el.scrollIntoView({ behavior: 'smooth' });
          else onNavigate('/services');
        }}
        onOpenConsultation={() => onOpenConsultation()}
        onStartProject={onStartProject}
      />

      <StatsSection />

      <AboutSection onLearnMore={() => onNavigate('/about')} />

      {/* Interactive Services Slider — animated, auto-cycling */}
      <ServicesSlider onSelectService={(slug) => onNavigate(`/services/${slug}`)} />

      {/* Static Services Grid below slider for quick overview */}
      <ServicesGrid onSelectService={(slug) => onNavigate(`/services/${slug}`)} />

      {/* Long-Term Website Care & Business Generation Commitment */}
      <LongTermCareSection 
        onStartProject={onStartProject || (() => onOpenConsultation('Long-Term Website Care'))}
        onOpenConsultation={() => onOpenConsultation('Long-Term Website Care & Maintenance')}
      />

      <MobileAppServices onLearnMore={() => onNavigate('/services/hybrid-mobile-app-development')} />

      {/* Vision & Mission — full dedicated section */}
      <VisionMissionSection />

      <CtaBanner onOpenConsultation={onOpenConsultation} />

      <PortfolioSection 
        onSelectProject={onSelectProject}
        onViewAllProjects={() => onNavigate('/portfolio')}
      />

      <WhyChooseUs />

      <ProcessSection />

      <TechStack />

      {/* Digital Marketing Keyword-Based Plans with Situation Matcher */}
      <DigitalMarketingPlans onSelectPlan={(plan) => onOpenConsultation(`Digital Marketing - ${plan}`)} />

      <Testimonials />

      <FaqSection onOpenConsultation={onOpenConsultation} />

      <ContactSection />
    </div>
  );
};
